const Nav = ($, context) => {

  const $openNav = $("#top-nav .open-link", context)
  const $closeNav = $("#full-nav .close-link", context)
  const $nav = $("#full-nav", context)

  const openNav = (e) => {
    e.preventDefault()
    $nav.addClass('open')
  }

  const closeNav = (e) => {
    e.preventDefault()
    $nav.removeClass('open')
  }

  var self = {
    init: () => {
      $openNav.on('click', openNav)
      $closeNav.on('click', closeNav)
    }
  }

  return self;
}

export default Nav